<template>
  <div class="d-flex flex-column flex-grow-1">
    <v-text-field
      class="mr-3"
      outlined
      :readonly="readonly"
      hide-details
      :value="value"
      :loading="loading || isLoading"
      :disabled="disabled"
      :error-messages="returnError"
      :id="idSuuggestView"
      :style="{ position: 'relative' }"
      @focus="focusSuggest"
      @input="showSuggest"
    />
    <div
      ref="suggestDropDown"
      :style="{ display: visibleSuggest, position: 'absolute' }"
    ></div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { loadYmap } from 'vue-yandex-maps'

export default {
  name: 'SuggestView',
  props: {
    value: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Object, Array],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      suggestView: null,
      idSuuggestView: null,
      isError: false,
      isLoading: false,
      visibleSuggest: 'none'
    }
  },
  computed: {
    returnError () {
      if (typeof this.errorMessages === 'object' || Array.isArray(this.errorMessages)) {
        if (
          this.errorMessages?.length === 0 ||
          Object.keys(this.errorMessages)?.length === 0
        ) {
          return null
        }
        if (typeof this.errorMessages === 'object') {
          if (!this.value) {
            return [this.errorMessages?.address || null]
          }
          return []
        }
        if (Array.isArray(this.errorMessages)) {
          return this.errorMessages[0]
        }
      }
      return this.errorMessages
    },
    isDark () {
      return this?.$vuetify?.theme?.isDark || false
    }
  },
  watch: {
    value () {
      this.hideSuggest()
    },
    isDark (val) {
      console.log(val)
    }
  },
  methods: {
    focusSuggest () {
      this.showSuggest()
    },
    showSuggest (e) {
      if (!!e && !e?.trim().length) {
        this.$emit('clear-location')
      }
      this.visibleSuggest = 'block'
    },
    hideSuggest () {
      this.visibleSuggest = 'none'
    },
    setIdSuggest () {
      this.idSuuggestView = `suggest${Date.now()}`
    },
    async init (settings) {
      this.isLoading = true
      await loadYmap({ ...settings, debug: true })
        .then(() => {
          this.suggestView = new ymaps.SuggestView(this.idSuuggestView, {
            container: this.$refs.suggestDropDown,
            width: 400
          })
        })
        .then(() => {
          this.suggestView.events.add('select', e => this.suggestViewSelected(e))
        })
        .then(() => (this.isLoading = false))
    },
    destroy () {
      if (this.suggestView && this.suggestView?.destroy) {
        this.suggestView.destroy()
        this.suggestView = null
      }
    },
    suggestViewSelected (event) {
      this.hideSuggest()
      this.$emit('input', event.originalEvent.item.displayName)
    },
    suggestInputHandler (e) {
      if (!e.trim().length) {
        this.$emit('clear-location')
      }
    }
  },
  beforeMount () {
    this.setIdSuggest()
  },
  async mounted () {
    const settings = {
      apiKey: process.env.VUE_APP_YANDEX_MAP_API_KEY,
      suggestApiKey: process.env.VUE_APP_YMAP_SUGGEST_API_KEY,
      lang: 'ru_RU',
      coordorder: 'latlong',
      enterprise: false,
      version: '2.1'
    }
    if (!this.suggestView) {
      try {
        await this.init(settings).then(() => (this.isError = false))
      } catch (e) {
        console.log(error)
        this.isError = true
      }
    }
  },
  destroyed () {
    this.destroy()
  }
}
</script>

<style>
.theme--dark ymaps[class$='search__suggest-item'],
.theme--dark ymaps[class$='search__suggest-highlight'] {
  color: #777;
}
</style>
